import { jsx as _jsx } from "react/jsx-runtime";
import { Route, Switch } from 'react-router-dom';
import { HR } from 'app/pages/HR/HR';
export default function () {
    return (_jsx(Switch, { children: _jsx(Route, { path: "/hr", component: HR }) }));
}
